module.exports = __webpack_public_path__ + "img/monaco.e30f04f3.svg";